export default [
  {
    path: "/merchant/list",
    name: "MerchantList",
    meta: {
      title: "商家列表",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/shop/merchant/list.vue")
  }
];
